export const API_M2M_URL = `${window.extended.REACT_APP_API_URL}/api/m2m`
export const API_M2M_IN_URL = `${window.extended.REACT_APP_API_URL}/api/m2m/in`
export const API_C2C_URL = `${window.extended.REACT_APP_API_URL}/api/c2c`
export const API_BANKS_URL = `${window.extended.REACT_APP_API_URL}/api/banks`
export const API_AUTH_URL = `${window.extended.REACT_APP_API_URL}/api/auth`
export const API_REGISTRATION_URL = `${window.extended.REACT_APP_API_URL}/api/registration-2`
export const API_OTP_AUTH_URL = `${window.extended.REACT_APP_API_URL}/api/auth/otp`
export const API_OPERATIONS_URL = `${window.extended.REACT_APP_API_URL}/api/operations`
export const API_PAYMENT_TOOLS_URL = `${window.extended.REACT_APP_API_URL}/api/payment-tools`
export const API_AGREEMENT_URL = `${window.extended.REACT_APP_API_URL}/api/agreement`
export const API_BANKS_PERMISSION_URL = `${window.extended.REACT_APP_API_URL}/api/bank-permissions`
export const API_ME_URL = `${window.extended.REACT_APP_API_URL}/api/me`
export const API_UPDATE_DEFAULT_BANK_REQUESTS_URL = `${window.extended.REACT_APP_API_URL}/api/update-default-bank-requests`
export const API_IDENTIFICATION_URL = `${window.extended.REACT_APP_API_URL}/api/identification-2`
export const API_SBP_COMBINED_PAYMENTS_MBANK_URL = `${window.extended.REACT_APP_API_URL}/api/sbp/combined-payments/mbank`
export const API_SBP_COMBINED_PAYMENTS_BY_ID_URL = `${window.extended.REACT_APP_API_URL}/api/sbp/combined-payments`
export const API_QUIT_URL = `${window.extended.REACT_APP_API_URL}/api/quit`
export const API_SBP_QRC_URL = `${window.extended.REACT_APP_API_URL}/api/sbp/qrc-data`
export const API_SBP_OUTCOME_PAYMENTS_URL = `${window.extended.REACT_APP_API_URL}/api/sbp/outcome-payments`

export const TRANSACTION_STATUS_POLL_INTERVAL = 2000
export const OK_RESPONSE = "OK"
export const NO_CONTENT = "No Content"

export const IDENTIFICATION_NON_CRITICAL_ERRORS = [
  'document_expired',
  'identification_request_not_found',
  'identification_request_already_exists',
  'document_already_exists',
  'inappropriate_identification_request_status',
  'invalid_document',
]
